import { defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "px-6 py-4" };
const _hoisted_2 = { class: "text-lg" };
const _hoisted_3 = { class: "mt-4" };
const _hoisted_4 = { class: "px-6 py-4 bg-gray-100 text-right" };
import Modal from '../Jetstream/Modal.vue';
export default /*#__PURE__*/ _defineComponent({
    props: {
        show: { default: false },
        maxWidth: { default: '2xl' },
        closeable: { default: true },
        showScrollHint: { default: false }
    },
    emits: ["close"],
    setup(__props, { emit }) {
        const props = __props;
        const close = () => emit('close');
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(Modal, {
                show: __props.show,
                "max-width": __props.maxWidth,
                closeable: __props.closeable,
                "show-scroll-hint": __props.showScrollHint,
                onClose: close
            }, {
                default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, [
                        _createElementVNode("div", _hoisted_2, [
                            _renderSlot(_ctx.$slots, "title")
                        ]),
                        _createElementVNode("div", _hoisted_3, [
                            _renderSlot(_ctx.$slots, "content")
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_4, [
                        _renderSlot(_ctx.$slots, "footer")
                    ])
                ]),
                _: 3
            }, 8, ["show", "max-width", "closeable", "show-scroll-hint"]));
        };
    }
});
